import { isNil } from 'lodash-es';
import cn from '@/utils/merge-class-names';

interface Props {
  show?: boolean;
  className?: string;
  children: string | number | null | undefined;
}

export default function Badge({ show = true, className, children }: Props) {
  if (!show || isNil(children)) return null;

  const childLength = children.toString().length;

  return (
    <span
      className={cn(
        'badge badge-sm badge-accent bg-red-500 h-3 text-[0.625rem] ring-1 border-0 ring-neutral-0 py-0 px-1',
        className,
        childLength === 0 && 'size-1.5 px-0 my-0.5',
        childLength > 2 && 'w-6 overflow-clip',
      )}>
      {children}
    </span>
  );
}
